module.exports = __webpack_public_path__ + "static/media/modelA_cmp2.c77c728e.gif";